import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import './assets/css/main.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,  
} from "react-router-dom";
import HomePage from './container/HomePage';
import Login from './container/Login';
import EventPage from './container/EventPage';
import CameraCard from './components/CameraCard';
import Events from './container/Events';
import withAuth from './utils/withAuth';
import { StoreProvider, useStoreRehydrated } from 'easy-peasy';
import Store from './modals';
import Logout from './container/Logout';
import AllGallery from './components/AllGallery';
import InstantCheckout from './container/InstantCheckout';
import DownloadPhotos from './container/DownloadPhotos';
import SaveSelection from './container/SaveSelection';
import OtpCardCheckout from './components/OtpCardCheckout';

function WaitForStateRehydration({ children }) {
  const isRehydrated = useStoreRehydrated();
  return isRehydrated ? children : null;
}

ReactDOM.render(
    <StoreProvider store={Store}>    
      <Router>
        <WaitForStateRehydration>
          <Switch>       
              <Route path={`${process.env.PUBLIC_URL + "/login"}`} component={Login} />
              <Route exact path={`${process.env.PUBLIC_URL + "/"}`} component={Login} />
              <Route exact path={`${process.env.PUBLIC_URL + "/login-checkout"}`} component={InstantCheckout} />
              <Route exact path={`${process.env.PUBLIC_URL + "/login-selection"}`} component={SaveSelection} />
              <Route exact path={`${process.env.PUBLIC_URL + "/login-profile"}`} component={SaveSelection} />
              <Route exact path={`${process.env.PUBLIC_URL + "/login-download"}`} component={SaveSelection} />
              <Route exact path={`${process.env.PUBLIC_URL + "/logout"}`} component={Logout} />
              <Route exact path={`${process.env.PUBLIC_URL + "/showroom/:id"}`} component={HomePage} />
              <Route exact path={`${process.env.PUBLIC_URL + "/download-photos/:slug"}`} component={withAuth(DownloadPhotos)} />
              <Route exact path={`${process.env.PUBLIC_URL + "/event/:id"}`} component={EventPage} />
              <Route exact path={`${process.env.PUBLIC_URL + "/photos/:eventname/:id"}`} component={EventPage} />
              <Route exact path={`${process.env.PUBLIC_URL + "/events"}`} component={withAuth(Events)} />
              <Route path={`${process.env.PUBLIC_URL + "/take-selfie"}`} component={CameraCard} />
             
          </Switch>
        </WaitForStateRehydration>
      </Router>
      </StoreProvider>,
  document.getElementById('root')
);
